/**
 * Design Tokens
 * Single source of truth for visual constants used across all components and pages.
 * Import these instead of hardcoding Tailwind classes so that a design change
 * propagates everywhere from one edit.
 */
// ---------------------------------------------------------------------------
// Border Radius
// ---------------------------------------------------------------------------
export const RADIUS = {
    /** Cards, modals, alerts, content containers */
    card: 'rounded-2xl',
    /** Buttons, inputs, form controls */
    control: 'rounded-xl',
    /** Badges, pills, tab pills */
    pill: 'rounded-full',
};
// ---------------------------------------------------------------------------
// Box Shadow
// ---------------------------------------------------------------------------
export const SHADOW = {
    /** Default resting state for cards */
    card: 'shadow-sm shadow-gray-900/5 dark:shadow-slate-950/20',
    /** Hover / elevated state */
    hover: 'shadow-md dark:shadow-lg dark:shadow-slate-950/30',
    /** Modals, popovers */
    modal: 'shadow-xl dark:shadow-2xl dark:shadow-slate-950/40',
    /** Active tab pill in dark bg */
    tabActive: 'shadow-lg shadow-slate-900/20',
    /** Subtle glassmorphic shadow (replaces pixel borders) */
    glass: 'shadow-[0_1px_3px_0_rgba(0,0,0,0.06)] dark:shadow-[0_1px_3px_0_rgba(0,0,0,0.3)]',
};
// ---------------------------------------------------------------------------
// Border Colors (light mode — dark mode handled via .dark overrides in CSS)
// ---------------------------------------------------------------------------
export const BORDER = {
    /** Subtle internal dividers (card header/footer) */
    subtle: 'border-gray-100 dark:border-slate-800',
    /** Standard card/component border */
    default: 'border-gray-200 dark:border-slate-700',
    /** Ultra-subtle glassmorphic divider */
    divider: 'border-gray-100/50 dark:border-slate-800/50',
    /** Form inputs keep visible borders for usability */
    input: 'border border-gray-300 dark:border-slate-700',
};
// ---------------------------------------------------------------------------
// Surface / Background Colors
// ---------------------------------------------------------------------------
export const SURFACE = {
    /** Page background */
    page: 'bg-gray-50 dark:bg-slate-950',
    /** Card / panel background (glassmorphic) */
    card: 'bg-white/60 backdrop-blur-sm dark:bg-slate-900/60',
    /** Inset content card (finding card, subjectivity row) */
    inset: 'bg-gray-50/80 dark:bg-slate-800/80',
    /** Page header (glassmorphic) */
    header: 'bg-white/80 backdrop-blur-sm dark:bg-slate-900/80',
    /** Opaque card — modals, dropdowns (no transparency) */
    cardSolid: 'bg-white dark:bg-slate-900',
};
// ---------------------------------------------------------------------------
// Default hero fallback image
// ---------------------------------------------------------------------------
export const DEFAULT_HERO_IMAGE = 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?q=80&w=2070&auto=format&fit=crop';
//# sourceMappingURL=design.js.map